import UserTypes from '../../enums/UserTypes';
import ARBalconista from '../../views/gerente/Index.vue';
import ARBMeusDados from '../../views/gerente/MeusDados.vue';
import ARBNovoLojista from '../../views/gerente/NovoLojista.vue';
import ARBPedidos from '../../views/gerente/Pedidos.vue';
import ARBSimularAcesso from '../../views/gerente/SimularAcesso.vue';

export default [
  {
    path: '/area-restrita/gerente-conta',
    name: 'gerente-conta',
    component: ARBalconista,
    children: [
      {
        path: '/area-restrita/gerente-conta/meus-dados',
        name: 'gerente-meus-dados',
        component: ARBMeusDados,
        meta: { userType: UserTypes.GERENTECONTA },
      },
      {
        path: '/area-restrita/gerente-conta/novo-lojista',
        name: 'novo-lojista-gerente',
        component: ARBNovoLojista,
        meta: { userType: UserTypes.GERENTECONTA },
      },
      {
        path: '/area-restrita/gerente-conta/pedidos-saldo',
        name: 'pedidos-lojista-gerente',
        component: ARBPedidos,
        meta: { userType: UserTypes.GERENTECONTA },
      },
      {
        path: '/area-restrita/gerente-conta/simular-acesso',
        name: 'simular-acesso-lojista-gerente',
        component: ARBSimularAcesso
      }
    ],
  },
];